// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"registrationProcessInit_wrapper__bJozx"};